


























import {
  defineComponent, ref, onMounted, onUnmounted, PropType,
} from '@vue/composition-api';

import OcrIdentity from '@/widgets/ocr-identity/OcrIdentity.vue';
import IdentityScoreDialog from '@/widgets/ocr-identity/components/identity-score-dialog/index.vue';

import { OcrProcessSourceEnum, UploadProcessTypeEnum, OcrOperationSourceEnum } from '@/shared/tools/ocr/enum';
import { TE_OCR_ENTER_NEW } from '@/shared/tools/ocr/tianqi/scan';
import {
  TP_OCR,
  TC_OCR_NOT_CLEAR,
  TE_OCR_NEXT_BASE_CHECK_SUCCEED,
  ubtButtonNewOcr,
  ubtExposeNewOcr,
} from '@/shared/tools/ocr/tianqi';
import UbtHelper from '@/shared/tools/ubtHelper';
import { agreementService } from '@/service/confirm-agreements';
import { session } from '@/shared/utils/storage';

export default defineComponent({
  components: {
    OcrIdentity,
    IdentityScoreDialog,
  },
  props: {
    /** verifyCredit组件用于判断是否是最后一步 - src/views_v2/verify-credit/index.tsx */
    processIsLastVerify: {
      type: Boolean,
      default: true,
    },
    /** verifyCredit组件判断是否编辑模式，VerifyEntireTypeEnum.MODIFY */
    isEditAction: {
      type: Boolean,
      default: false,
    },
    /** verifyCredit是否强制检测身份证清晰分 */
    isCheckIdentityClarityScore: {
      type: Boolean,
      default: false,
    },
    /** 是否展示保存按钮 */
    showSaveConfirm: {
      type: Boolean,
      default: false,
    },
    processSource: {
      type: Number as PropType<OcrProcessSourceEnum>,
      default: OcrProcessSourceEnum.OTHER,
    },
    operationSource: {
      type: String as PropType<OcrOperationSourceEnum>,
      default: OcrOperationSourceEnum.GENERAL,
    },
    ocrAfter: {
      type: Boolean,
      default: false,
    },
    ocrAfterLoan: {
      type: Boolean,
      default: false,
    },
    isLoanProcess: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /** 上一步 - 非极简 - base-info入口 */
    'cancel',
    /** 极简流程成功回调 - verifyCredit入口 */
    'resolveProcessVerify',
    /** 非极简成功回调 - base-info入口 */
    'success',
  ],
  setup(props, context) {
    const { $router } = context.root;
    const identityScoreRef = ref();
    /** 是否展示上一步 */
    const showLastStep = ref(false);
    /** 提交按钮状态 */
    const showSave = ref(false);

    /** 成功回调处理 */
    const onResolveProcessVerify = async (options: { mode: string }) => {
      await identityScoreRef.value.updatedIdentityScore(OcrProcessSourceEnum.OTHER);

      /** 是否身份证清晰分不足，清晰分不足则增加埋点 */
      const isIdentityNotClear = () => identityScoreRef.value.confirmShouldIdentityScore(() => {
        ubtButtonNewOcr(TC_OCR_NOT_CLEAR, {
          uploadType: options.mode,
          processType: UploadProcessTypeEnum.SCAN,
        });
      });

      /** 点击下一步按钮，身份证基建校验成功 埋点 */
      const ubtOcrBaseCheckSucceed = () => {
        ubtExposeNewOcr(TE_OCR_NEXT_BASE_CHECK_SUCCEED, {
          uploadType: options.mode,
          processType: UploadProcessTypeEnum.SCAN,
          msgSource: session.get('ocrMsgSource'),
          scene: props.processSource,
        });
      };

      /**
       * 同意协议成功后，身份证清晰分校验通过后，进行流程处理
       * resolveProcessVerify是verifycredit身份证上传成功后的流程处理函数
       */
      if (await agreementService.confirmFinanceAgreements()) {
        if (!props.isEditAction) {
          if (props.isCheckIdentityClarityScore && isIdentityNotClear()) {
            ubtOcrBaseCheckSucceed();
            context.emit('resolveProcessVerify');
          } else if (!props.isCheckIdentityClarityScore) {
            ubtOcrBaseCheckSucceed();
            context.emit('resolveProcessVerify');
          }
        } else {
          /** 检验身份证清晰分，若满足则提交，否则中断  */
          if (isIdentityNotClear()) {
            ubtOcrBaseCheckSucceed();

            context.emit('resolveProcessVerify');
          }
        }
      }
    };

    const initData = () => {
      showLastStep.value = false;
      showSave.value = !!props.showSaveConfirm;
    };

    const onCancel = () => {
      context.emit('cancel');
    };

    const ubtHelper = new UbtHelper(TP_OCR);

    onMounted(() => {
      ubtHelper.enterPage();
      ubtExposeNewOcr(TE_OCR_ENTER_NEW);
      initData();
    });

    onUnmounted(() => {
      ubtHelper.leavePage();
    });

    return {
      identityScoreRef,
      showLastStep,
      showSave,

      onCancel,
      onResolveProcessVerify,
    };
  },
});
